interface SkipLinkProps {
    mainContentTranslation: string;
    quickSearchTranslation: string;
    footerTranslation: string;
    quickSearchId: string;
    mainContentId: string;
    footerId: string;
}
const SkipNavLinks = ({
    mainContentTranslation,
    quickSearchTranslation,
    footerTranslation,
    quickSearchId,
    mainContentId,
    footerId,
    ...props
}: SkipLinkProps) => {
    const handleGoToContent = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        id: string
    ) => {
        event.preventDefault();
        const elem = document.getElementById(id);
        if (elem) {
            elem.setAttribute('tabindex', '-1');
            elem.focus();
            elem.removeAttribute('tabindex');
        }
    };

    return (
        <div className="absolute -m-px flex h-px w-px gap-4 overflow-hidden border-2 border-black p-0 [clip:rect(0_0_0_0)] focus-within:fixed focus-within:left-2 focus-within:top-0 focus-within:z-[1001] focus-within:h-auto focus-within:w-auto focus-within:bg-white focus-within:p-4 focus-within:[clip:auto] ">
            <a
                {...props}
                onClick={event => handleGoToContent(event, mainContentId)}
                href={`#${mainContentId}`}
            >
                {mainContentTranslation}
            </a>
            <a
                {...props}
                onClick={event => handleGoToContent(event, quickSearchId)}
                href={`#${quickSearchId}`}
            >
                {quickSearchTranslation}
            </a>
            <a
                {...props}
                onClick={event => handleGoToContent(event, footerId)}
                href={`#${footerId}`}
            >
                {footerTranslation}
            </a>
        </div>
    );
};

export default SkipNavLinks;
